<template>
  <div>
    <div class="programme-summary-table-container">
      <k-table
        :rows="tableRows"
        :headers="headers"
        :header-order="headerOrder"
        :max="50"
        :downloadable="true"
        :filename="tableFilename"
      />
    </div>
  </div>
</template>

<style scoped>
.programme-summary-table-container :deep(.k-table-panel) {
  padding: 15px;
}

.programme-summary-table-container :deep(.k-table-container th.k-table-header-last_submission) {
  min-width: 200px;
}
</style>

<script>
import KTable from '@base-components/tables/display/k-table.vue';
import { formatId } from '@utils/format-user-id';

export default {
  components: {
    'k-table': KTable,
  },
  props: {
    rows: {
      type: Array,
      required: true,
    },
    programmeId: {
      type: Number,
    },
  },
  data: () => ({
    tableRows: [],
    headerOrder: ['learner', 'name', 'email', 'account_activated', 'last_submission'],
  }),

  computed: {
    headers() {
      return {
        learner: {
          name: 'User ID',
          sortable: true,
          type: 'string',
          hideable: false,
        },
        name: {
          name: 'Name',
          type: 'url',
          filterable: true,
          sortable: true,
          hideable: false,
        },
        email: {
          name: 'Email',
          type: 'string',
          filterable: true,
          sortable: true,
          hideable: true,
        },
        account_activated: {
          name: 'Account Activated',
          type: 'timestamp',
          sortable: true,
          hideable: false,
        },
        last_submission: {
          name: 'Last Submission',
          sortable: true,
          type: 'timestamp',
          options: {
            tooltip: true,
            tooltipText: 'Last submission on an assignment, quiz, or questionnaire',
          },
        },
      };
    },
    tableFilename() {
      const dt = new Date().toISOString().split('T')[0];
      return `programme-summary-${this.programmeId}-${dt}.csv`;
    },
  },
  watch: {
    rows: {
      handler() {
        this.buildTableRows();
      },
      immediate: true,
    },
  },
  methods: {
    buildTableRows() {
      const output = [];
      let name;
      let email;
      let entry;
      for (let i = 0; i < this.rows.length; i++) {
        entry = this.rows[i];
        name = this.rows[i].full_name;
        email = this.rows[i].email;
        entry = Object.assign(entry, {
          learner: formatId(this.rows[i].user_id),
          name: {
            text: name,
            path: { name: 'dashboard_students', params: { studentId: this.rows[i].user_id } },
          },
          email,
        });
        output.push(entry);
      }
      this.tableRows = Object.freeze(output);
    },
  },
};
</script>
